import * as React from "react"
import styled from "styled-components"
import { FC, useContext } from "react"
import { BasketContext } from "../../context/BasketProvider"
import Spinner from "../Spinner"
import { Icon } from "semantic-ui-react"
import BasketTotals from "../../pages/basket/BasketTotals"
import BasketItems from "../../pages/basket/BasketItems"
import { borderGrey } from "../../constants/colors"
import { navigate } from "gatsby"
import { PrimaryButton, SideModal } from "components"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;

  h5 {
    margin: 0;
  }

  i {
    cursor: pointer;
    margin: 0;
  }
`
const Body = styled.div`
  padding: 0 20px;
  overflow: auto;
  flex: 1;
`
const Message = styled.h4`
  padding-top: 80px;
  text-align: center;
`
const Footer = styled.div`
  border-top: 1px solid ${borderGrey};
  padding: 10px;
`

interface Props {}

const BasketSidebar: FC<Props> = ({}) => {
  const basketContext = useContext(BasketContext)
  const { toggle, isOpen, isLoading } = basketContext

  const isBasketEmpty = !basketContext.basket.items.length

  const handleClick = () => {
    toggle(false)
    setTimeout(() => {
      navigate("/basket")
    }, 200)
  }

  return (
    <SideModal show={isOpen} onClose={toggle} right>
      <Spinner isLoading={isLoading} />
      <Container>
        <Header>
          <h5>Your Basket</h5>
          <Icon name="close" size="large" onClick={toggle} />
        </Header>
        <Body>
          {isBasketEmpty ? (
            <Message>Please add some products to proceed with checkout</Message>
          ) : (
            <BasketItems items={basketContext.basket.items} adjustable />
          )}
        </Body>
        <Footer>
          <BasketTotals showCountdown />
          <PrimaryButton onClick={handleClick} disabled={isBasketEmpty} fullWidth>
            Basket / Checkout
          </PrimaryButton>
        </Footer>
      </Container>
    </SideModal>
  )
}

export default BasketSidebar
